import styled, { css } from 'styled-components';
import {
    IconPlus, Text, mediaMixin, spaceMixin,
} from '@zillow/constellation';
import { Spinner } from '@zillow/zrs-comet';

export const StyledAppointmentDiv = styled.div`
    display: flex;
    flex-direction: row;
    padding-bottom: ${spaceMixin('xs')};
`;

export const StyledBtnContainerDiv = styled.div`
    display: inline-block;
    width: 250px;
    padding-left: ${spaceMixin('sm')};
    vertical-align: top;
`;

export const StyledContactHoursDiv = styled.div`
    display: inline-block;
    width: calc(100% - 90px);
    ${mediaMixin('lg', css`
        width: calc(100% - 125px);
    `)};
`;

export const StyledDayLabelText = styled(Text)`
    width: 90px;
    display: inline-block;
    margin-top: ${spaceMixin('xs')};
    ${mediaMixin('lg', css`
        width: 125px;
    `)};
`;

export const StyledDropzoneContainerDiv = styled.div`
    display: flex;
    flex-flow: column;
    height: 200px;

    .DropzoneContainer {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    p {
        position: absolute;
        margin-top: ${spaceMixin(0)};
        top: 10px;
    }
`;

export const StyledIconPlus = styled(IconPlus)`
    position: absolute;
    top: 70px;
`;

export const StyledPropertyLogoDiv = styled.div`
    text-align: center;
    margin-bottom: ${spaceMixin('xs')};
    ${mediaMixin('lg', css`
        text-align: left;
    `)};
`;

export const StyledSpinner = styled(Spinner)`
    position: absolute;
    top: 70px;
`;

export const StyledUploadedLogoDiv = styled.div`
    display: inline-block;
    padding-bottom: ${spaceMixin('sm')};
    width: 250px;
`;
